(function () {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .factory('ProjectInitService', ProjectInitService);

    ProjectInitService.$inject = ['$log', '$localStorage', '$sessionStorage', 'Auth', '$sce', '$q', '$window', 'ProjectService', 'JhiLanguageService', 'NO_PROJECT_URL'];

    function ProjectInitService($log, $localStorage, $sessionStorage, Auth, $sce, $q, $window, ProjectService, JhiLanguageService, NO_PROJECT_URL) {
        return {
            initProject: initProject
        };

        function initProject(project) {
            var deferred = $q.defer();

            if (project !== undefined) {
                $localStorage.$reset();
                $sessionStorage.$reset();
                Auth.logout();

                return ProjectService.validateProject(project).then(
                    storeProjectInLocalStorage,
                    function (response) {
                        $log.debug('ProjectInitService | ERROR', response);
                        $window.location.assign(NO_PROJECT_URL);

                        deferred.resolve(response);
                    }
                );
            } else {
                setProjectInfo();
                deferred.resolve();
            }

            return deferred.promise;
        }

        function storeProjectInLocalStorage(response) {
            $log.debug('ProjectInitService | Project-Id received: ', response.data);

            if (isInteger(response.data) && response.data > 0) {
                var project = response.data;
                $localStorage.project = project;

                return loadProjectInfo(project);
            } else {
                $log.debug('ProjectInitService | ERROR getting project-id, go to', NO_PROJECT_URL);
                $window.location.assign(NO_PROJECT_URL);

                return $q.resolve();
            }
        }

        function isInteger(value) {
            return typeof value === "number" &&
                isFinite(value) &&
                Math.floor(value) === value;
        }

        function loadProjectInfo(project) {
            return ProjectService.loadProjectInfo(project)
                .then(function (response) {
                    $log.debug('ProjectInitService | Project info fetching successful', response);
                    $localStorage.projectinfo = response.data;
                    setProjectInfo();

                    return $q.resolve(response);
                }, function (data) {
                    $log.debug('ProjectInitService | error fetching project info', data);

                    return $q.resolve(data);
                });
        }

        function setProjectInfo() {
            $log.debug('ProjectInitService | Project-Info: ', $localStorage.projectinfo);

            if ($localStorage.projectinfo !== undefined) {
                JhiLanguageService.setLanguages($localStorage.projectinfo.languages);
            } else {
                $window.location.assign(NO_PROJECT_URL);
            }
        }
    }
})();
